import { GridComparatorFn, GridSortCellParams } from "@mui/x-data-grid-pro";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";

const PARKING_DIAG_ID = "a8Q59homXrESC9eF_I_JTWA";

function getRowFromParams(params: GridSortCellParams): DeviceStatusOverviewData {
  const apiAny = params.api as any;
  // v6+: getRow(id) exists; fall back to getRowModels() if needed
  return apiAny.getRow?.(params.id) ?? apiAny.getRowModels?.().get(params.id);
}

function isParkingBrakeActive(row: DeviceStatusOverviewData): boolean {
  const val = row?.statusData?.statusData?.find(d => d.diagnostic.id === PARKING_DIAG_ID)?.data;
  return [1, 3].includes(val as number);
}

function isDriving(row: DeviceStatusOverviewData): boolean {
  return Boolean(row?.statusData?.isDriving);
}

function rank(row: DeviceStatusOverviewData): number {
  if (isDriving(row)) return 0; // driving first
  if (isParkingBrakeActive(row)) return 1; // then parking
  return 2; // then the rest
}

export const drivingSortComparator: GridComparatorFn<any> = (
  v1: any,
  v2: any,
  p1: GridSortCellParams,
  p2: GridSortCellParams,
) => {
  const r1 = rank(getRowFromParams(p1));
  const r2 = rank(getRowFromParams(p2));
  if (r1 !== r2) return r1 - r2;

  // stable tiebreaker (optional)
  const a = getRowFromParams(p1)?.device?.name ?? getRowFromParams(p1)?.device?.id ?? "";
  const b = getRowFromParams(p2)?.device?.name ?? getRowFromParams(p2)?.device?.id ?? "";
  return a.localeCompare(b);
};
